// client/src/hooks/usePagarmeRecipient.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import useAlert from './useAlert';
import { useAuth } from '../context/auth/AuthProvider';

// Recipient ID do Pagar.me (destino do split quando a cobrança de Sinal
// precisa passar pela credencial da franquia/matriz — ver
// server/services/gatewayResolver.js). Conta e franquia guardam esse valor
// em campos diferentes (Account.pagarmeRecipientId / Franquia.recipientId),
// então este hook esconde essa diferença atrás de uma interface só.
export const usePagarmeRecipient = () => {
    const { scope, franquiaId } = useAuth();
    const { setAlert } = useAlert();
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['pagarme-recipient', scope, franquiaId],
        queryFn: async () => {
            if (scope === 'conta') {
                const { data } = await api.get('/contas/my/details');
                return data.data?.pagarmeRecipientId || '';
            }
            if (scope === 'franquia' && franquiaId) {
                const { data } = await api.get(`/franquias/${franquiaId}`);
                return data.data?.recipientId || '';
            }
            return '';
        },
        enabled: scope === 'conta' || (scope === 'franquia' && !!franquiaId),
    });

    const mutation = useMutation({
        mutationFn: async (recipientId) => {
            if (scope === 'conta') {
                return api.put('/contas/my/details', { pagarmeRecipientId: recipientId });
            }
            if (scope === 'franquia') {
                return api.put(`/franquias/${franquiaId}`, { recipientId });
            }
            throw new Error('Escopo não suportado para Recipient ID.');
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['pagarme-recipient'] });
            setAlert('Recipient ID salvo com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || err.response?.data?.message || 'Erro ao salvar Recipient ID.', 'error'),
    });

    return {
        recipientId: query.data || '',
        isLoading: query.isLoading,
        save: mutation.mutate,
        isSaving: mutation.isPending,
    };
};

export default usePagarmeRecipient;
